import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {
  GetTwoFactorSMSDisable,
  GetTwoFactorSMSEnable,
  SendEmailTwoFA,
  SendSMSTwoFA,
  TwoFactorSMSDisable,
  TwoFactorSMSEnable,
} from "store/api/security";
import { useEffect, useState } from "react";

import CountdownButton from "components/CountdownButton";
import { LoadingButton } from "@mui/lab";
import { allowMaxCharLength } from "utils/helpers/allowMaxCharLength";
import { authenticationAppSchema } from "utils/validations/securitySchemas";
import http from "config/http";
import { useForm } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { yupResolver } from "@hookform/resolvers/yup";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function SMSForm({ status, onClose, onSuccess }) {
  const notify = useNotify();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);

  const [authenticationDetails, setAuthenticationDetails] = useState(null);

  const {
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      emailCode: "",
      smsCode: "",
      appCode: "",
    },
    resolver: yupResolver(
      authenticationAppSchema({
        isShowSMS: authenticationDetails?.isShowSMS,
        isShowApp: authenticationDetails?.isShowApp,
      })
    ),
  });

  const onSubmit = async (payload) => {
    const url = status ? TwoFactorSMSDisable : TwoFactorSMSEnable;
    try {
      setLoading(true);

      await http.post(url, payload);

      notify(`SMS با موفقیت ${status ? "غیر فعال" : "فعال"} شد.`, "success");
      onSuccess();
      onClose();
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false);
  };

  const handleGetEmailCode = async (startCountDown) => {
    try {
      await http.get(SendEmailTwoFA);

      startCountDown();
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleGetSMSCode = async (startCountDown) => {
    try {
      await http.get(SendSMSTwoFA);

      startCountDown();
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getAuthenticationDetails = async () => {
    const url = status ? GetTwoFactorSMSDisable : GetTwoFactorSMSEnable;

    try {
      const { data } = await http.get(url);

      setAuthenticationDetails(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getAuthenticationDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography textAlign="right" variant="label">
            Email: {authenticationDetails?.email}
          </Typography>

          <TextField
            dir="rtl"
            placeholder="کد ارسالی به ایمیل خود را وارد کنید"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CountdownButton
                    onClick={handleGetEmailCode}
                    time={authenticationDetails?.validSecondsSendEmail}
                  />
                </InputAdornment>
              ),
            }}
            error={!!errors?.emailCode}
            helperText={errors?.emailCode?.message}
            value={watch("emailCode")}
            onChange={(e) =>
              allowMaxCharLength({
                name: "emailCode",
                value: e.target.value,
                setValue,
                length: 6,
              })
            }
          />
        </Grid>

        {authenticationDetails?.isShowApp && (
          <Grid item xs={12}>
            <TextField
              dir="rtl"
              placeholder="کد Authentication App را وارد کنید"
              error={!!errors?.appCode}
              helperText={errors?.appCode?.message}
              value={watch("appCode")}
              onChange={(e) =>
                allowMaxCharLength({
                  name: "appCode",
                  value: e.target.value,
                  setValue,
                  length: 6,
                })
              }
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography textAlign="right" variant="label">
            Phone: {authenticationDetails?.phoneNumber}
          </Typography>

          <TextField
            dir="rtl"
            placeholder="کد SMS ارسالی را وارد کنید"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CountdownButton
                    onClick={handleGetSMSCode}
                    time={authenticationDetails?.validSecondsSendSMS}
                  />
                </InputAdornment>
              ),
            }}
            error={!!errors?.smsCode}
            helperText={errors?.smsCode?.message}
            value={watch("smsCode")}
            onChange={(e) =>
              allowMaxCharLength({
                name: "smsCode",
                value: e.target.value,
                setValue,
                length: 6,
              })
            }
          />
        </Grid>

        <Grid item xs={6}>
          <Button color="info" fullWidth onClick={onClose}>
            انصراف
          </Button>
        </Grid>

        <Grid item xs={6}>
          <LoadingButton
            variant="contained"
            loading={loading}
            type="submit"
            fullWidth
            color={status ? "error" : actionButtonBg(theme)}
          >
            {status ? "غیر فعال کردن" : "فعال کردن"}
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
}

export default SMSForm;
